export const countOrderItemsSum = (orderItems) =>
	orderItems.reduce((prev, next) => prev + next.price, 0);
